export interface FeatureFlagConfig {
  id: string;
  key: string;
  title: string;
  description: string;
  disabled?: boolean;
}

export const FEATURE_FLAGS: FeatureFlagConfig[] = [
  {
    id: 'systemConfigToggle',
    key: 'enableSystemConfiguration',
    title: 'System Configurations',
    description:
      'It includes location configuration and external configuration for non ST customers.',
    disabled: true,
  },
  {
    id: 'asyncModeToggle',
    key: 'enableAsyncMode',
    title: 'Enable Async Mode',
    description: 'This allows TFI to process payments asynchronously.',
  },
];
